import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Cookie, X } from 'lucide-react';

const STORAGE_KEY = 'ns_cookie_consent';

export default function CookieConsent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            const v = localStorage.getItem(STORAGE_KEY);
            if (!v) setVisible(true);
        } catch {
            setVisible(true);
        }
    }, []);

    const save = (choice) => {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify({ choice, at: new Date().toISOString() }));
        } catch { /* noop */ }
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            data-testid="cookie-consent-banner"
            className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-6 lg:left-auto lg:right-6 lg:max-w-md z-[150]"
        >
            <div
                className="bg-white border border-[var(--ns-border)] rounded-2xl shadow-xl p-5 sm:p-6"
                style={{ boxShadow: '0 18px 40px -12px rgba(29,45,68,0.25)' }}
            >
                <div className="flex items-start gap-3">
                    <span
                        className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0"
                        style={{ background: 'var(--ns-soft)' }}
                    >
                        <Cookie size={16} className="text-[var(--ns-clay)]" />
                    </span>
                    <div className="flex-1 min-w-0">
                        <div className="font-display font-semibold text-[var(--ns-text)]">A quick note on cookies</div>
                        <p className="text-sm text-[var(--ns-text2)] mt-1 leading-relaxed">
                            We use cookies to keep you logged in and improve your experience.
                        </p>
                        <div className="flex items-center gap-2 mt-4 flex-wrap">
                            <Button
                                onClick={() => save('accepted')}
                                data-testid="cookie-consent-accept"
                                className="rounded-full h-9 px-4 text-white text-sm"
                                style={{ background: 'var(--ns-navy)' }}
                            >
                                Accept
                            </Button>
                            <Button
                                onClick={() => save('declined')}
                                variant="outline"
                                data-testid="cookie-consent-decline"
                                className="rounded-full h-9 px-4 text-sm border-[var(--ns-border)] text-[var(--ns-text2)]"
                            >
                                Decline non-essential
                            </Button>
                        </div>
                    </div>
                    <button
                        type="button"
                        onClick={() => save('dismissed')}
                        data-testid="cookie-consent-close"
                        aria-label="Dismiss"
                        className="text-[var(--ns-text3)] hover:text-[var(--ns-text)] p-1"
                    >
                        <X size={16} />
                    </button>
                </div>
            </div>
        </div>
    );
}
